import CaterIndustry from "../../Sections/CaterIndustry";
import FirstTime from "../../Sections/FirstTime";
import HowItWorks from "../../Sections/HowItWorks";
import ServiceCard from "../../Sections/ServiceCard";
import BottomNav from "../../Layout/BottomNav";
import ConvertedPrice from "../ConvertedPrice";

const ResidentialPage = (props: any) => {
  return (
    <>
      {/* <Navbar static={true} /> */}

      <BottomNav />

      {/* <WeCanDO /> */}

      <div className="blur-background-box">
        <div className="hp-container">
          <div className="page-title pt-5 pb-5 mb-5" data-aos="fade-up">
            <h1>Our Services</h1>
            <p>
              Help your buyers visualize their business setup in a comfy and
              efficient environment by virtually transforming the vacant
              property.
            </p>
          </div>

          <ServiceCard
            imageFront={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Virtual_Staging_After_1_Web_1749852752.webp`}
            imageBack={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Virtual_Staging_Before_1_Web_1749852752.webp`}
            description="Furnish your empty spaces with our virtual staging service. Realistic, stunning images enable buyers to visualize the full potential of any property, whether it’s an office or any part of your business space."
            title="Virtual Staging"
            isPlaceOrder={false}
            key={1}
            pageUrl="/virtual-staging"
            exploreBtn={true}
            listItems={[
              <span>
                <b>Guaranteed Best Prices</b> at{" "}
                <b>{<ConvertedPrice price={16} />}</b>
              </span>,
              <span>
                <b>Lightning Fast Turnaround</b> in <b>24-48 hours</b>
              </span>,
              <span>
                <b>Rapid Delivery</b> in <b>just 24 hours</b>
              </span>,
              <b>Free Unlimited Revisions</b>,
              <b>Risk-Free Guarantee**: 100% money-back</b>,
            ]}
          />

          <div className="mt-5 mb-5">
            <ServiceCard
              imageFront={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Virtual_Renovation_After_1_Web_1749998916.webp`}
              imageBack={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Virtual_Renovation_Before_1_Web_1749998917.webp`}
              description="Revitalize your empty commercial spaces with high-quality, lifelike images. Highlight possibilities through stunning visuals, creating a compelling narrative. By showcasing your property's unique features, we ensure your listings stand out and lead to faster sales."
              title="Virtual Renovation"
              isPlaceOrder={false}
              key={1}
              pageUrl="/virtual-renovation"
              exploreBtn={true}
              listItems={[
                <span>
                  <b>
                    Guaranteed Best Prices starting from
                    {<ConvertedPrice price={5} />}
                  </b>
                </span>,
                <span>
                  <b>Lightning Fast Turnaround</b> in <b>24-48 hours</b>
                </span>,
                <span>
                  <b>Rapid Delivery</b> in <b>just 24 hours</b>
                </span>,
                <b>Free Unlimited Revisions</b>,
                <b>Risk-Free Guarantee**: 100% money-back</b>,
              ]}
            />
          </div>
          <ServiceCard
            imageFront={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/2D_Floor_Plan_With_Furniture_After_Web_1749844403.webp`}
            imageBack={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/2D_Floor_Plan_With_Furniture_Before_Web_1749844403.webp`}
            description="2D floor plan service, with and without furniture, to give precise visualizations of property layouts."
            title="Floor Plan"
            isPlaceOrder={false}
            classes={["mb-5"]}
            key={1}
            pageUrl="/services/floor-plan-form"
            exploreBtn={true}
            listItems={[
              <span>
                <b>Guaranteed Best Price</b>
              </span>,
              <span>
                <b>Lightning Fast Turnaround</b> in <b>24-48 hours</b>
              </span>,
              <span>
                <b>Rapid Delivery</b> in <b>just 24 hours</b>
              </span>,
              <b>Free Unlimited Revisions</b>,
              <b>Risk-Free Guarantee**: 100% money-back</b>,
            ]}
          />

          <div className="page-title pt-5 pb-5" data-aos="fade-up">
            <h1>Other Services</h1>
          </div>
          <ServiceCard
            imageFront={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Day_to_Dusk_After_1_Web_1749829341.webp`}
            imageBack={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Day_to_Dusk_Before_1_Web_1749829341.webp`}
            description="Transforms daytime photos into captivating, twilight-inspired photos, enhancing their visual appeal."
            title="Day to Dusk"
            classes={["mb-5"]}
            isPlaceOrder={true}
            key={1}
            pageUrl="/services/day-to-dusk-form"
            price={<ConvertedPrice price={5} />}
            listItems={[
              <span>
                <b>Guaranteed Best Price </b>at{" "}
                <b>{<ConvertedPrice price={5} />}</b>
              </span>,
              <span>
                <b>Lightning Fast Turnaround</b> in <b>24-48 hours</b>
              </span>,
              <span>
                <b>Rapid Delivery</b> in <b>just 24 hours</b>
              </span>,
              <b>Free Unlimited Revisions</b>,
              <b>Risk-Free Guarantee**: 100% money-back</b>,
            ]}
          />

          <ServiceCard
            imageFront={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Object_Removal_After_2_Web_1749849991.webp`}
            imageBack={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Object_Removal_Before_2_Web_1749849991.webp`}
            description="Object removal service in real estate photography seamlessly erases unwanted elements, enhancing property images for 
a pristine presentation."
            title="Object Removal"
            isPlaceOrder={true}
            key={1}
            pageUrl="/services/commercial/object-removal"
            price={<ConvertedPrice price={8} />}
            classes={["mb-5"]}
            listItems={[
              <span>
                <b>Guaranteed Best Price </b>at{" "}
                <b>{<ConvertedPrice price={8} />}</b>
              </span>,
              <span>
                <b>Lightning Fast Turnaround</b> in <b>24-48 hours</b>
              </span>,
              <span>
                <b>Rapid Delivery</b> in <b>just 24 hours</b>
              </span>,
              <b>Free Unlimited Revisions</b>,
              <b>Risk-Free Guarantee**: 100% money-back</b>,
            ]}
          />

          <ServiceCard
            imageFront={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Image_Enhancement_After_1_Web_1749847955.webp`}
            imageBack={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Image_Enhancement_Before_1_Web_1749847955.webp`}
            description="Converting an occupied space into a vacant one can enhance the property's cleanliness and often leads to increased demand."
            title="Image Enhancement"
            isPlaceOrder={true}
            key={1}
            pageUrl="/services/image-enhancement-form"
            price={<ConvertedPrice price={1.5} />}
            classes={["mb-4"]}
            listItems={[
              <span>
                <b>Guaranteed Best Price </b>at{" "}
                <b>{<ConvertedPrice price={15} />}</b>
              </span>,
              <span>
                <b>Lightning Fast Turnaround</b> in <b>24-48 hours</b>
              </span>,
              <span>
                <b>Rapid Delivery</b> in <b>just 24 hours</b>
              </span>,
              <b>Free Unlimited Revisions</b>,
              <b>Risk-Free Guarantee**: 100% money-back</b>,
            ]}
          />

          <ServiceCard
            imageFront={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Occupied_to_Vacant_After_2_Web_1749851204.webp`}
            imageBack={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Occupied_to_Vacant_Before_2_Web_1749851204.webp`}
            description="Converting an occupied space into a vacant one can enhance the property's cleanliness and often leads to increased demand."
            title="Occupied To Vacant"
            isPlaceOrder={true}
            key={1}
            pageUrl="/services/occupied-vacant-form"
            price={<ConvertedPrice price={15} />}
            classes={["mb-4"]}
            listItems={[
              <span>
                <b>Guaranteed Best Price </b>at{" "}
                <b>{<ConvertedPrice price={15} />}</b>
              </span>,
              <span>
                <b>Lightning Fast Turnaround</b> in <b>24-48 hours</b>
              </span>,
              <span>
                <b>Rapid Delivery</b> in <b>just 24 hours</b>
              </span>,
              <b>Free Unlimited Revisions</b>,
              <b>Risk-Free Guarantee**: 100% money-back</b>,
            ]}
          />
        </div>

        {/* ========== How it works ========== */}
        <HowItWorks redirectionLink={"/virtual-staging"} />

        <div className="hp-container">
          {/* First time */}
          <div data-aos="fade-up">
            <FirstTime />
          </div>

          {/* Industry we are catering */}
          <div data-aos="fade-up">
            <CaterIndustry />
          </div>
        </div>
      </div>
    </>
  );
};

export default ResidentialPage;
